module.exports = __webpack_public_path__ + "img/img21.5bd1f4e4.png";